<template>
  <div v-if="ruleFilters && ruleFilters.length > 1" :class="['filter-box', { disabled: disabled }]">
    <div class="heading" @click="toggleFilter">
      <fieldset>
        <input :id="`${filterId}-global`" v-model="groupFilter" :disabled="disabled" :value="true" type="checkbox" />
        <label :for="`${filterId}-global`" class="title">{{ title }}</label>
      </fieldset>
      <div class="filter-cta">
        <i :class="`icon-${active ? 'arrow_up' : 'arrow_down'}`"></i>
      </div>
    </div>

    <div v-if="active" class="form-container">
      <Draggable v-model="ruleFilters" :item-key="element => ruleFilters.indexOf(element)" @end="saveOrder()">
        <template #item="{ element, index }">
          <div class="fieldset">
            <input :id="`${filterId}-${index}`" v-model="filter" :disabled="disabled" :value="element" type="checkbox" />
            <label :for="`${filterId}-${index}`">{{ element }}</label>
          </div>
        </template>
      </Draggable>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Draggable from 'vuedraggable';
import { useSignalR } from '@dreamonkey/vue-signalr';

export default {
  components: { Draggable },
  props: ['filterId', 'title', 'disabled', 'filters'],

  data() {
    return {
      ruleFilters: this.filters,
      active: true,
    };
  },

  computed: {
    ...mapGetters({
      isDesktop: 'isDesktop',
      allFilters: 'filters',
      study: 'study',
    }),

    filter: {
      get() {
        return this.allFilters[this.filterId];
      },

      set(newVal) {
        this.groupFilter = newVal.length === this.ruleFilters.length;
        this.updateParams(newVal, this.filterId);
      },
    },

    groupFilter: {
      get() {
        return this.filter.length === this.ruleFilters.length;
      },

      set(newVal) {
        if (!newVal) {
          if (this.filter.length === this.ruleFilters.length) {
            this.updateParams([], this.filterId);
          }
        } else {
          this.updateParams(this.ruleFilters, this.filterId);
        }
      },
    },
  },

  watch: {
    filters() {
      this.ruleFilters = this.filters;
    },
  },

  created() {
    this.$socket = useSignalR();
  },

  methods: {
    updateParams(newVal, parameter) {
      this.$store.dispatch('updateFilters', {
        key: parameter,
        value: newVal,
      });
      if (!this.isDesktop || this.$route.name === 'Controller') {
        if (this.study && this.study.collaborators_total > 2000) {
          const id = this.study.id || this.$route.params.studyId;
          this.$store.dispatch('uploadRawData', { id: id, content: this.$store.getters.screen() }).then(result => {
            this.$socket.invoke('action', { action: 'tvBlob', parameters: result });
          });
        } else {
          this.$socket.invoke('action', { action: 'tvData', parameters: this.$store.getters.screen() });
        }
      }
    },

    toggleFilter() {
      this.active = !this.active;
    },

    saveOrder() {
      this.$emit('save', { filterId: this.filterId, values: this.ruleFilters });
    },
  },
};
</script>

<style lang="scss" scoped>
@use '@/styles/colors.scss';

.filter-box {
  padding-left: 26px;
  padding-right: 10px;
  background-color: white;

  & + .filter-box {
    border-top: 1px solid colors.$clear-border-color;
  }

  .fieldset {
    height: 16px;
    display: flex;

    & + .fieldset {
      margin-top: 10px;
    }

    &:last-child {
      padding-bottom: 12px;
    }
  }

  &.disabled {
    [type='checkbox']:not(:checked) + label:after,
    [type='checkbox']:checked + label:after {
      background-color: colors.$nude-concrete-color;
    }

    [type='checkbox']:checked + label:before {
      border-color: colors.$nude-concrete-color;
    }
  }

  .heading {
    fieldset {
      border: none;
      margin-left: -1.15em;
      padding: 8px 0;
    }

    [type='checkbox']:not(:checked) + label:before,
    [type='checkbox']:checked + label:before {
      top: 15px;
    }

    [type='checkbox']:not(:checked) + label:after,
    [type='checkbox']:checked + label:after {
      top: 18px;
    }
  }
}
</style>
